export default __webpack_public_path__ + "static/media/edited-9.4be457a9.jpg";